import { CenteredSpinner } from "@sonify/web-ui";

export interface LoadingStateProps {
  message?: string;
}

export function LoadingState({ message }: LoadingStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 gap-3">
      <CenteredSpinner size="md" />
      {message && <p className="text-sm text-foreground-muted">{message}</p>}
    </div>
  );
}
